import React from "react";

const Footer = () => {
  return (
    <footer className="flex flex-col items-center  text-center text-surface  dark:text-white dark:bg-[#18181b]">
      <div className="w-full p-4 text-center">
        © 2024 Copyright.
        <a className="font-semibold pl-2 dark:text-[#6366f1]" href="/">
          GOOD VIBZ
        </a>
      </div>
    </footer>
  );
};

export default Footer;
